import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDAccordion,
  FDAccordionDetails,
  FDAccordionTitle,
  FDIcon,
  FDPaper,
  FDPrimaryActionButton,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { dataAttrs } from 'Helpers/Testing';
import metaOverrideSet from '../../MetaOverrideSet/metaOverrideSet';

const Disclaimer = ({ resource, expandedId, onAccept }) => {
  const [expanded, setExpanded] = React.useState(expandedId === resource.id());
  const isAccepted = resource.attr('accepted') === 'true';
  const canSubmit = resource.meta().canSubmit();

  React.useEffect(() => {
    if (expandedId === resource.id()) {
      setExpanded(true);
    }
  }, [expandedId]);


  return (
    <FDPaper appearance={'elevated'}>
      <FDAccordion
        expansionID={resource.id()}
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        {...dataAttrs(`${resource.id()}-disclaimer`)}
      >
        <FDAccordionTitle>
          <FDStack direction={'row'} spacing={2}>
            {isAccepted ? <FDIcon icon={'checkCircleIcon'} color={'success'} /> : null}
            <FDTitleText value={resource.attr('title')} />
          </FDStack>
        </FDAccordionTitle>
        <FDAccordionDetails>
          <FDStack direction="column" spacing={3}>

            <MetaControl resource={resource} attrName={'body'} metaOverrideSet={metaOverrideSet} />
            <FDStack direction={'row'} justifyContent={'center'}>
              <FDPrimaryActionButton
                onClick={() => {
                  resource.attr('accepted', 'true');
                  setExpanded(false);
                  onAccept(resource.id());
                }}
                label="Acknowledge and accept"
                disabled={isAccepted || !canSubmit}
              />
            </FDStack>
          </FDStack>
        </FDAccordionDetails>
      </FDAccordion>
    </FDPaper>


  );
};

Disclaimer.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  expandedId: PropTypes.string.isRequired,
  onAccept: PropTypes.func.isRequired,
};

Disclaimer.defaultProps = {};

export default Disclaimer;
